module.exports = __webpack_public_path__ + "img/news_4.d1de6547.png";